module.exports = __webpack_public_path__ + "static/img/bg_jinrongzhichi.f8f4e87.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_jinrongzhichi.png
// module id = NkXm
// module chunks = 1